import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { useSpring, animated } from 'react-spring';

import {
  SEARCH_IN,
  SEARCH_STATES_ITEMS
} from '../../../_shared/constants/search';
import { TradeStateNew } from '../../../_shared/types/trade';

import StyledNav from './Styles';

const SearchNav = ({
  onTradeStateClick,
  preSelectedTradeState,
  searchIn,
  locale,
  isOmp
}) => {
  const [position, setPosition] = useState({
    left: isOmp ? '0px' : '12px',
    width: '85px'
  });
  const [tradeState, setTradeState] = useState(
    preSelectedTradeState || SEARCH_STATES_ITEMS[0]
  );

  const animationProps = useSpring({
    from: {
      opacity: 0
    },
    left: position.left,
    width: position.width,
    opacity: 1
  });

  useEffect(() => {
    let currentTradeStateRef;
    if (tradeState && !tradeState.id) {
      const searchState = SEARCH_STATES_ITEMS.find(searchItem => {
        return searchItem.context === Number(tradeState);
      });
      currentTradeStateRef = document?.getElementById(
        `searchLink-${searchState?.id}`
      );
    } else {
      currentTradeStateRef = document?.getElementById(
        `searchLink-${tradeState.id}`
      );
    }
    if (
      searchIn === SEARCH_IN.BUY &&
      preSelectedTradeState === TradeStateNew.ALL
    ) {
      currentTradeStateRef = document?.getElementById(
        `searchLink-${SEARCH_STATES_ITEMS[0].id}`
      );
    }
    if (currentTradeStateRef) {
      const { offsetLeft, offsetWidth } = currentTradeStateRef;

      if (Number.isInteger(offsetLeft) && Number.isInteger(offsetWidth)) {
        setPosition({
          left: offsetLeft,
          width: offsetWidth
        });
      }
    }
  }, [tradeState, searchIn, preSelectedTradeState]);

  const onSearchNavClick = item => {
    if (item) {
      setTradeState(item);
      onTradeStateClick(item.context);
    }
  };

  return (
    <StyledNav isOmp={isOmp}>
      <ul data-testid="searchStates">
        {SEARCH_STATES_ITEMS.map(item => {
          let label;
          if (locale === 'fr-CA') {
            label = isOmp ? item.labelOmpFr ?? item.labelFr : item.labelFr;
          } else {
            label = isOmp ? item.labelOmp ?? item.label : item.label;
          }
          if (
            searchIn === SEARCH_IN.BUY &&
            (item.context === TradeStateNew.LOST ||
              item.context === TradeStateNew.PARKED)
          ) {
            return null;
          }
          return (
            <li
              key={item.id}
              id={`searchInnerNav-${item.id}`}
              data-testid={`searchInnerNav-${item.id}`}
            >
              <Link
                to={`${item.label}`}
                smooth
                id={`searchLink-${item.id}`}
                tabIndex={0}
                onClick={() => onSearchNavClick(item)}
                className={`searchLink-${
                  item.context === tradeState.context
                    ? 'selected'
                    : `${item.id}`
                }`}
              >
                {label}
              </Link>
            </li>
          );
        })}
      </ul>
      <animated.div className="search-active-state" style={animationProps} />
    </StyledNav>
  );
};

export default SearchNav;
